module.exports = __webpack_public_path__ + "img/cutting-edge-cn-1 copy.fb7bb77.jpg";